<em class="mdi mdi-alert-circle mdi-18px" aria-hidden="true"></em> &nbsp;

<span [ngSwitch]="message">
  <span *ngSwitchCase="0">{{ 'itinerary-actions.not-emited' | translate }}</span>
  <span *ngSwitchCase="1">{{ 'itinerary-actions.select-option' | translate }}</span>
  <span *ngSwitchCase="2">{{
    'itinerary-actions.select-passenger-and-itinerary' | translate
  }}</span>
  <span *ngSwitchCase="5">{{ 'itinerary-actions.click-button' | translate }}</span>
  <span *ngSwitchCase="6">{{ 'itinerary-actions.cant-involuntary-change' | translate }}</span>
  <span *ngSwitchCase="7">{{ 'itinerary-actions.received-from-required' | translate }}</span>
</span>
